/**
 * Scrolls the main viewport and common scroll roots to the top.
 * Avoid picking only `body` first: in standards mode the document scroll position
 * often lives on `document.documentElement`, so `body.scrollTop` can be a no-op.
 */
export function scrollMainContentToTop(): void {
  window.scrollTo({ top: 0, left: 0, behavior: 'auto' });

  const html = document.documentElement;
  if (html) html.scrollTop = 0;

  const body = document.body;
  if (body) body.scrollTop = 0;

  const scrolling = document.scrollingElement as HTMLElement | null;
  if (scrolling && scrolling !== html) {
    scrolling.scrollTop = 0;
  }

  const root = document.getElementById('root');
  if (root) root.scrollTop = 0;

  const main = document.querySelector('.wrapper .body');
  if (main) main.scrollTop = 0;
}
